<template xmlns:v-bind="http://www.w3.org/1999/xhtml" xmlns:v-el="http://www.w3.org/1999/xhtml">
  <button
    class="edit-button"
    @click.stop="onClick">
    <icon-edit />
  </button>
</template>

<script type="text/babel">
  import { IconEdit } from '@/common/icons/monochrome';

  export default {
    components: {
      IconEdit,
    },
    props: {
      entity: {
        type: Object,
      },
      column: {
        type: Object,
      },
      callback: {
        type: Function,
      },
    },
    methods: {
      onClick(e) {
        // this.$emit(TableEvents.EDIT_FIELD, { event: e, entity: this.entity, column: this.column });
        this.callback({ event: e, item: this.entity, column: this.column });
      },
    },
  };
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
  @use '@/styles/variables.scss' as *;
  .edit-button {
    align-items: center;
    justify-content: center;
    position: absolute;
    right: 0.6rem;
    cursor: pointer;
    border-radius: 0.5rem;
    box-shadow: 0 0 8px #00000033;
    border: none;
    width: 2.4rem;
    height: 2.4rem;

    background: var(--actionsColorReverse);

    svg {
      width: 1.2rem;
      height: 1.2rem;

      fill: var(--actionsColor);
      stroke: var(--actionsColor);
    }

    &:hover {
      display: flex;

      background: var(--actionsColor);

      svg {
        fill: var(--actionsColorReverse);
        stroke: var(--actionsColorReverse);
      }
    }
  }
</style>
